import gql from 'graphql-tag';

export const ADD_MEMBERS_TO_PROGRAMS_MUTATION = gql`
  mutation AddMembersToProgramsMutation($query: JSONObject, $memberIds: [Int!], $programIds: [Int!]!, $status: String, $utmSource: String, $clientId: String) {
    success: membersAddToPrograms(query: $query, memberIds: $memberIds, programIds: $programIds, status: $status, utmSource: $utmSource, clientId: $clientId)
  }
`;
